'use client';

import { useTranslations } from 'next-intl';
import { useEffect, useState } from 'react';

type TimerProps = {
  initialTime?: number;
  onTimerEnd: () => void;
};

export function Timer({ initialTime = 60, onTimerEnd }: TimerProps) {
  const t = useTranslations('LoginForm'); // Assuming translations are in LoginForm namespace
  const [timeLeft, setTimeLeft] = useState(initialTime);

  useEffect(() => {
    if (timeLeft === 0) {
      onTimerEnd();
      return;
    }

    const intervalId = setInterval(() => {
      setTimeLeft((prevTime) => prevTime - 1);
    }, 1000);

    return () => clearInterval(intervalId);
  }, [timeLeft, onTimerEnd]);

  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;

  return (
    <div className="flex flex-col items-center justify-center">
      <p className="font-medium text-muted-foreground text-sm">
        {t('resendCodeTimer')}
      </p>
      <p className="font-bold text-foreground text-xl">
        {minutes.toString().padStart(1, '0')}:
        {seconds.toString().padStart(2, '0')}
      </p>
    </div>
  );
}
